import { createStore } from '../.'

import type { StateStorage } from 'zustand/middleware'
import { ChainOption } from '../../interfaces/common'

interface SelectedChainStore {
  selectedChain: ChainOption
  setSelectedChain: (chain: ChainOption) => void
}

export const createSelectedChainStore = (storage: StateStorage) =>
  createStore<SelectedChainStore>(
    storage,
    (set) => ({
      selectedChain: 'all',
      setSelectedChain(selectedChain) {
        set({ selectedChain })
      },
    }),
    {
      persist: {
        name: 'selectedChain',
      },
    }
  )
